<template>
    <v-dialog v-model="openMode" max-width="500px">
        <v-card class="numbers-dialog">
            <v-card-title class="dialog-header">
                <v-icon left class="ml-2" dark>mdi-phone-plus</v-icon>
                הוסף מספרים למאגר סוכן
            </v-card-title>

            <v-card-text>
                <v-container class="numbers-container">
                    <!-- Numbers Input -->
                    <v-card outlined class="numbers-input-card">
                        <v-card-title class="numbers-input-title">
                            <v-icon color="#0d2c6d" class="ml-2">mdi-format-list-numbered</v-icon>
                            רשימת מספרים
                        </v-card-title>
                        <v-card-text>
                            <v-textarea v-model="numbers" class="numbers-textarea" outlined rows="8" dense
                                label="הכנס מספרים, שורה חדשה לכל מספר" @keypress="filterNumeric"
                                @input="enforceMaxCharsPerLine"></v-textarea>
                        </v-card-text>
                    </v-card>

                    <!-- Number Type -->
                    <v-card outlined class="settings-card mt-4">
                        <v-card-title class="settings-title">
                            <v-icon color="#0d2c6d" class="ml-2">mdi-cog</v-icon>
                            הגדרות
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-select :items="types" v-model="type" outlined dense label="סוג"
                                        class="input-field"></v-select>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="belongToAgent" outlined dense type="number" hide-spin-buttons
                                        label="שייך לסוכן" class="input-field"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete :items="coutryCodes" v-model="calleridCountryCodesChoosed"
                                        item-text="he" item-value="en" outlined dense multiple chips small-chips
                                        label="בחר מדינות לשיחות יוצאות" :rules="[v => !!v || 'שדה חובה']" required
                                        class="input-field"></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="dialog-actions">
                <v-btn color="primary" class="add-button" @click="addNumbers" :loading="progressShow"
                    :disabled="progressShow || !numbers">
                    <v-icon left>mdi-phone-plus</v-icon>
                    הוסף מספרים
                </v-btn>
                <v-btn color="grey lighten-3" @click="closeDelete">
                    סגור
                </v-btn>
            </v-card-actions>
        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import sharedFunctions from '@/shared/sharedFunctions';

export default {
    props: {
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        numbers: "",
        belongToAgent: null,
        type: "מספר כללי",
        types: ["מספר כללי", "פתיחת מערכת"],
        coutryCodes: [],
        calleridCountryCodesChoosed: ["IL"]
    }),

    methods: {
        async addNumbers() {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                const itemsJSON = JSON.stringify({
                    numbers: this.numbers.split('\n').filter(n => n.trim()),
                    belongToAgent: this.belongToAgent,
                    type: this.type,
                    calleridCountryCodes: this.calleridCountryCodesChoosed
                });

                let api = process.env.VUE_APP_BASE_URL + "/admin_api/add_numbers";
                const res = await fetch(api, ApiServices.requestOptions("POST", itemsJSON, token));
                const jsonObject = await res.json();
                this.progressShow = false;
                if (res.status >= 400) {
                    this.showSnackBar("שגיאה בהוספת מספרים: " + jsonObject, "red");
                } else if (res.status === 200) {
                    this.showSnackBar("המספרים נוספו בהצלחה!", "green");
                    this.numbers = "";
                    this.openMode = false;
                }
            } catch (error) {
                this.progressShow = false;
                this.showSnackBar("שגיאה בהוספת מספרים: " + error, "red");
            }
        },
        async getCountryCodes() {
            this.coutryCodes = await sharedFunctions.getCountryCodes();
        },
        closeDelete() {
            this.openMode = false;
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true;
        },
        filterNumeric(event) {
            const charCode = event.charCode;
            // Allow numeric keys (0-9) and the Enter key for line breaks
            if ((charCode < 48 || charCode > 57) && charCode !== 13) {
                event.preventDefault();
            }
        },
        enforceMaxCharsPerLine(event) {
            const MAX_CHARS_PER_LINE = 13;
            let modified = false;
            const lines = this.numbers.split('\n').map(line => {
                if (line.length > MAX_CHARS_PER_LINE) {
                    modified = true;
                    return line.substring(0, MAX_CHARS_PER_LINE);
                }
                return line;
            });

            if (modified) {
                this.$nextTick(() => {
                    this.numbers = lines.join('\n');
                });
            }
        }
    },
    computed: {
        openMode: {
            get() {
                return this.value;
            },
            set(v) {
                return this.$emit('input', v);
            }
        },
    },
    mounted() {
        this.getCountryCodes();
    }
}
</script>

<style scoped>
.numbers-dialog {
    border-radius: 12px;
    overflow: hidden;
    direction: rtl;
    font-family: 'Heebo', sans-serif;
}

.dialog-header {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
    color: white;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 16px;
}

.numbers-container {
    padding: 16px 0;
}

.numbers-input-card,
.settings-card {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.numbers-input-card:hover,
.settings-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.numbers-input-title,
.settings-title {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
    padding: 12px 16px;
    margin-bottom: 12px;
    background-color: rgba(13, 44, 109, 0.05);
}

.numbers-textarea {
    font-family: 'Courier New', monospace;
    font-size: 16px;
}

.input-field {
    border-radius: 8px;
}

.dialog-actions {
    padding: 16px;
    display: flex;
    justify-content: flex-start;
}

.add-button {
    background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
    color: #0d2c6d !important;
    font-weight: 600;
    margin-left: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.add-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Custom scrollbar */
.numbers-textarea::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    border-radius: 8px;
}

.numbers-textarea::-webkit-scrollbar-thumb {
    background-color: #0d2c6d;
    border-radius: 8px;
}

.numbers-textarea::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .dialog-actions {
        flex-direction: column;
    }

    .add-button {
        margin-left: 0;
        margin-bottom: 8px;
        width: 100%;
    }
}
</style>